import styled from "styled-components";

export const Gradient = styled.div`
  background: linear-gradient(
    90deg,
    rgb(8, 107, 151) 0%,
    rgb(105, 186, 213) 100%
  );
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto;
  gap: 16px;
  padding: 1rem 3.25rem;
  width: 100%;
  max-width: 1440px;
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: 100%;
    min-width: 100%;
    padding: 1rem;
  }
`;

export const StreamContainer = styled.div`
  display: grid;
  width: 100%;
  max-width: 720px;
  margin: auto;
  grid-template-columns: 1fr;
`;

export const Stream = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    border: none;
  }
`;
